import clsx, { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const MEDIA_TYPES = {
  VIDEO: 'video',
  AUDIO: 'audio',
  IMAGE: 'image',
};

export const ASSET_TYPES = {
  [MEDIA_TYPES.IMAGE]: ['.png', '.jpg', '.svg', '.webp', '.jpeg', '.tif'],
  [MEDIA_TYPES.VIDEO]: ['.mp4', '.webm'],
  [MEDIA_TYPES.AUDIO]: ['.mp3', '.wav', '.ogg'],
};

export const ASSET_TYPE_MAP = Object.keys(ASSET_TYPES).reduce((a, k) => {
  ASSET_TYPES[k].forEach((e) => {
    a[e] = k;
  });
  return a;
}, {});

export function getMediaType(filename) {
  const r = new RegExp(`${Object.keys(ASSET_TYPE_MAP).join('$|')}$`, 'gi');
  const match = r.exec(filename.toLowerCase());
  return (match && ASSET_TYPE_MAP[match[0]]) || null;
}

export function getAssetsOfType(arr, type) {
  return arr.filter((a) => getMediaType(a.filename) === type);
}

export function getVideos(arr) {
  return getAssetsOfType(arr, MEDIA_TYPES.VIDEO);
}

export function getImages(arr) {
  return getAssetsOfType(arr, MEDIA_TYPES.IMAGE);
}

export function getAudio(arr) {
  return getAssetsOfType(arr, MEDIA_TYPES.AUDIO);
}

export function getRawS3(filename) {
  return filename.replace(
    'https://a-us.storyblok.com',
    '//s3.amazonaws.com/a.storyblok.com'
  );
}

export function getCorsPath(filename) {
  if (!filename) return filename;
  return filename.replace('//a-us.storyblok.com', '//a2-us.storyblok.com');
}

export function getFilename(path) {
  return path.split('/').pop();
}

// eslint-disable-next-line prefer-regex-literals
const emailCheck = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);
export function validateEmail(str) {
  if (!str) return false;
  return emailCheck.test(str);
}

export function validateString(str) {
  if (!str) return false;
  return str.length > 0;
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getStoryblokImageUrl(
  filename: string,
  width: number = 1024,
  height: number = 0
) {
  return `${filename}/m/${width}x${height}`;
}
